import { render, staticRenderFns } from "./OrderAddButton.vue?vue&type=template&id=07a8701d&scoped=true&"
import script from "./OrderAddButton.vue?vue&type=script&lang=js&"
export * from "./OrderAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a8701d",
  null
  
)

export default component.exports